module.exports = __webpack_public_path__ + "static/media/Nashville.1af703e2.jpg";